import React, { useState } from 'react';
import './LoginForm.css';

const LoginForm = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();

    if (username.trim() && password.trim()) {
      onLogin(username, password);
    } else {
      setError('Введите имя пользователя и пароль');
    }
  };

  return (
    <div className="login-container"> 
      {/* Вместо анимации — просто фон. Линии убраны. */}

      <div className="login-card">
        <h1>Вход</h1>
        <form onSubmit={handleLogin} className="login-form">
          <input
            type="text"
            placeholder="Имя пользователя"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Пароль"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit">Войти</button>
          {error && <p className="error-message">{error}</p>}
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
